import React, {Component} from 'react';
import {Mainentry} from '../entries'
import {WithModal} from '../';
import styles from './style.css';


export default class Main extends WithModal {
    render() {
        return (
            <div className={[this.props.className, styles.App].join(' ')}>
                <Mainentry {...this.props} openModal={this.openModal.bind(this)}/>
                <div className={"row"}>
                    <div className={"col-md-12 screenText"}>
                        <p>Главная страница автоматизированного рабочего места (АРМ) в режиме реального времени
                            отображает
                            информацию об основных технико-экономических показателях работы узла электроиндукционного
                            нагрева автоматизированного (ВЕНА).
                        </p>
                        <p>Для получения подробной информации о работе узла нагрева перейдите на закладки
                            «Гидравлическая»,
                            «Тепловая», «Электрическая», «Экономическая», «Энергетическая» (наведите курсор на
                            интересующую
                            Вас закладку и, при появлении символа <i className="fa fa-hand-pointer-o"></i>,
                            нажмите на левую кнопку мыши).
                        </p>
                    </div>
                </div>
                { (()=> {
                    return super.render();
                })()
                }
            </div>
        );
    }
}







// WEBPACK FOOTER //
// ./src/components/Main/index.jsx